import { LOADER_START, LOADER_STOP } from './constant';

export const loaderStart = () => dispatch => {
    dispatch({ type: LOADER_START, payload: true });
};

export const loaderStop = () => dispatch => {
    dispatch({ type: LOADER_STOP, payload: false });
};

export const callLoader = (val) => dispatch => {
    if (val === 1 || val === true) {
        dispatch(loaderStart());
    } else {
        dispatch(loaderStop());
    }
}